import React, { useEffect, useState } from 'react';

/** PSEO 落地页 v0 模板类型，与 Essio templateConfig 字段对应。 */
export type V0LandingKind = 'video' | 'image' | 'seedance';

const V0_LOADERS: Record<V0LandingKind, () => Promise<{ default: React.ComponentType }>> = {
  video: () => import('@/components/landing_page/components/v0_video_page/index'),
  image: () => import('@/components/landing_page/components/v0_image_page/index'),
  seedance: () => import('@/components/landing_page/components/seedance_page/index'),
};

interface LazyV0SlotProps {
  kind: V0LandingKind;
}

/**
 * 按 templateConfig 仅在运行时加载对应 v0 子应用，避免页面模块顶层 static dynamic 一次性编译全部 v0 chunk。
 */
function LazyV0Slot({ kind }: LazyV0SlotProps) {
  const [Comp, setComp] = useState<React.ComponentType | null>(null);

  useEffect(() => {
    let cancelled = false;
    V0_LOADERS[kind]().then((mod) => {
      if (!cancelled) {
        setComp(() => mod.default);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [kind]);

  if (!Comp) {
    return null;
  }

  return <Comp />;
}

export default LazyV0Slot;
